var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.79961 6.7999C3.79961 3.26528 6.66499 0.399902 10.1996 0.399902H35.7996C39.3342 0.399902 42.1996 3.26528 42.1996 6.7999V45.1999C43.9669 45.1999 45.3996 46.6326 45.3996 48.3999C45.3996 50.1672 43.9669 51.5999 42.1996 51.5999H30.3996C29.8473 51.5999 29.3996 51.1522 29.3996 50.5999V41.9999C29.3996 40.2326 27.9669 38.7999 26.1996 38.7999H19.7996C18.0323 38.7999 16.5996 40.2326 16.5996 41.9999V50.5999C16.5996 51.1522 16.1519 51.5999 15.5996 51.5999H3.79961C2.0323 51.5999 0.599609 50.1672 0.599609 48.3999C0.599609 46.6326 2.0323 45.1999 3.79961 45.1999V6.7999ZM13.3996 9.9999H19.7996V16.3999H13.3996V9.9999ZM19.7996 22.7999H13.3996V29.1999H19.7996V22.7999ZM26.1996 9.9999H32.5996V16.3999H26.1996V9.9999ZM32.5996 22.7999H26.1996V29.1999H32.5996V22.7999Z",
    fill: "#9EA3AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.039ae62323793ad5f087c076ad449fa9.svg";
export { ForwardRef as ReactComponent };